import { mergeStyles } from "@fluentui/react";

export const pageContainerClass = mergeStyles({
  display: "flex",
  flexDirection: "column",
  padding: "8px 12px",
  paddingBottom: 64,
  height: "100vh",
  boxSizing: "border-box",
  minHeight: 0,
});
